import { Award } from "lucide-react";

export interface RewardsComingSoonProps {
  /**
   * Which copy variant to render:
   * - "partner" → BDM/PO ("Recognising your impact" / "Rewards coming soon.")
   * - "admin"   → CM/RM/RA ("Rewards program coming soon")
   */
  audience: "partner" | "admin";
}

/**
 * Rewards "coming soon" placeholder (CHP-430). Rendered in place of the dormant
 * SPIF-earnings dashboard on the `/spifs` routes — Rewards is NOT cancelled, it
 * is parked behind this placeholder until the programme surface is built. See
 * ADR-0033 (supersedes ADR-0031 §4). Copy is provisional pending Steph/team
 * refinement (CHP-430 note).
 *
 * CHP-888: enlarged and brought onto the brand. The old neutral `EmptyState`
 * dashed panel read as "missing content"; this larger coral-tinted panel (the
 * brand-tint surface + coral icon chip used elsewhere for branded chips/cards)
 * reads as a designed "coming soon" moment, in line with the platform UI.
 */
export function RewardsComingSoon({ audience }: RewardsComingSoonProps) {
  const title = audience === "partner" ? "Recognising your impact" : "Rewards program coming soon";
  const hint = audience === "partner" ? "Rewards coming soon." : null;

  return (
    <div className="container py-6">
      <div className="mt-4 flex flex-col items-center justify-center gap-5 rounded-xl border border-brand-tint-border bg-brand-tint px-6 py-20 text-center">
        <span
          aria-hidden
          className="flex h-16 w-16 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-brand-glow"
        >
          <Award className="h-8 w-8" />
        </span>
        <div className="space-y-1.5">
          <p className="text-2xl font-semibold text-brand-tint-foreground">{title}</p>
          {hint ? <p className="text-sm text-brand-tint-foreground/80">{hint}</p> : null}
        </div>
      </div>
    </div>
  );
}
